// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import 'babel-polyfill';
import router from './router';
import App from './App.vue';
import './assets/styles/main.scss';

Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);

window.bus = new Vue({});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  data: {
    API_ENDPOINT: process.env.API_ENDPOINT
  },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js